<!--
    This component is used to navigate to external links.
    Allows to preserve scroll position when navigating back.
 -->
<script lang="ts" setup>
import { navigateToUrl } from '@nzyme/vue-utils/navigateToUrl.js';
import { computed } from 'vue';

interface Props {
  href: string;
  newTab?: boolean;
}

const props = defineProps<Props>();

const rel = computed(() => {
  if (props.href.startsWith('http')) {
    return 'noopener noreferrer nofollow';
  }

  return undefined;
});

function onClick(event: MouseEvent) {
  if (props.newTab) {
    return;
  }

  if (event.ctrlKey || event.metaKey) {
    return;
  }

  event.preventDefault();

  navigateToUrl(props.href);
}

function withoutProtocol(url: string) {
  if (url.startsWith('http://')) {
    return url.substring(7);
  }

  if (url.startsWith('https://')) {
    return url.substring(8);
  }

  return url;
}
</script>

<template>
  <a
    :href="href"
    :rel="rel"
    :target="newTab ? '_blank' : undefined"
    @click="onClick"
  >
    <slot>{{ withoutProtocol(href) }}</slot>
  </a>
</template>
